import { useState } from 'react';
import { useAuthStore } from '../stores/useAuthStore';
import { signOut } from '../lib/supabase/auth';

export function UserMenu() {
  const session = useAuthStore((s) => s.session);
  const setSession = useAuthStore((s) => s.setSession);
  const [warning, setWarning] = useState<string | null>(null);

  if (!session) return null;

  async function handleSignOut() {
    const { error } = await signOut();
    setSession(null); // fail-closed: always clear local state
    if (error) {
      console.error('[auth] server-side signOut failed:', error);
      setWarning(
        'Signed out locally, but the server could not confirm. Clear browser data to be safe.',
      );
    }
  }

  const email = session.user.email ?? 'signed in';
  const initial = email.charAt(0).toUpperCase();

  return (
    <div className="flex flex-col gap-2 p-3">
      <div className="flex items-center gap-2.5">
        <div
          aria-hidden
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-500/20 text-sm font-semibold text-primary-300"
        >
          {initial}
        </div>
        <span
          className="flex-1 truncate text-sm text-slate-200"
          title={email}
        >
          {email}
        </span>
        <button
          type="button"
          onClick={handleSignOut}
          className="shrink-0 rounded-md px-2 py-1 text-xs font-medium text-slate-400 transition-colors hover:bg-slate-700/50 hover:text-white"
        >
          Sign out
        </button>
      </div>
      {warning && (
        <p
          role="alert"
          className="rounded-md border border-amber-700/60 bg-amber-900/30 px-2 py-1.5 text-xs text-amber-200"
        >
          {warning}
        </p>
      )}
    </div>
  );
}
